<!--工业物联网在线峰会-->
<template>
  <div>
    <ChildrenPage
      :id="2"
      :imgs="[
    require('../assets/imgs/2-1.png'),
    require('../assets/imgs/2-2.png'),
    require('../assets/imgs/2-3.png'),
     require('../assets/imgs/2-4.png')
    ]"
    />
  </div>
</template>

<script>
import ChildrenPage from "../components/ChildrenPage";
export default {
  components: {
    ChildrenPage
  },
  filters: {},
  watch: {},
  computed: {},
  data() {
    return {};
  },
  methods: {},
  async created() {},
  mounted() {
    window.scrollTo(0, 0);
  },
  updated() {
    // if (this.setFontSize) {
    //   this.bigSize();
    // }
  },
  beforeDestroy: function() {},
  destroyed() {}
};
</script>

